import React, { useState } from 'react'

export default function About() {
    const[mystyle,setMystyle]  = useState({
        color:'white',
        backgroundColor:'black',
        barder:'2px solid white'
    })
    const[btntext,setBtntext]= useState("Enable To Dark Mode")
    const toglystyle=()=>{
        if(mystyle.color==='black'){
            setMystyle({
                color:'white',
                backgroundColor:'black',
                barder:'2px solid white'
            })
            setBtntext("Enable To Light mode")
        }
        else{
            setMystyle({
                color:'black',
                backgroundColor:'white',
                barder:'2px solid white'  
            })
            setBtntext("Enable To Dark mode") 
        }
    }
  return (
    <div className='container' style={mystyle}>
        <h1 className='my-3'>About Us</h1>
      <div  className="accordion" id="accordionExample">
  <div  className="accordion-item">
    <h2  className="accordion-header">
      <button  className="accordion-button"style={mystyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        Accordion Item #1
      </button>
    </h2>
    <div id="collapseOne"  className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
      <div  className="accordion-body"style={mystyle}>
        <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div  className="accordion-item">
    <h2  className="accordion-header">
      <button  className="accordion-button collapsed"style={mystyle} type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
        Accordion Item #2
      </button>
    </h2>
    <div id="collapseTwo"  className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div  className="accordion-body"style={mystyle}>
        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div  className="accordion-item">
    <h2  className="accordion-header">
      <button  className="accordion-button collapsed" style={mystyle}type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
        Accordion Item #3
      </button>
    </h2>
    <div id="collapseThree"  className="accordion-collapse collapse" data-bs-parent="#accordionExample">
      <div  className="accordion-body"style={mystyle}>
        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
</div>
<div className="container">
<button onClick={toglystyle} type="button"  className="btn btn-primary my-3">{btntext}</button>
    </div>
    </div>
  )
}
